import { ReactNode } from 'react'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ContentHeaderPluginState {
  /**
   * @deprecated
   * Avoid using this approach
   */
  rightSlot: ReactNode
  pluginEnabled: boolean
}

const initialState: ContentHeaderPluginState = {
  rightSlot: null,
  pluginEnabled: false,
}

export const contentHeaderPluginSlice = createSlice({
  name: 'contentHeaderPlugin',
  initialState,
  reducers: {
    setContentHeaderPluginRightSlot(state, { payload }: PayloadAction<ReactNode>) {
      state.rightSlot = payload
    },
    setContentHeaderPluginEnabled(state, { payload }: PayloadAction<boolean>) {
      state.pluginEnabled = payload
    },
  },
})

/**
 * @deprecated
 * DO NOT USE REDUX FOR PASSING `ReactNode`
 */
export const { setContentHeaderPluginRightSlot } = contentHeaderPluginSlice.actions
export const { setContentHeaderPluginEnabled } = contentHeaderPluginSlice.actions

export default contentHeaderPluginSlice.reducer
